import { render, staticRenderFns } from "./CreateBinNumber.vue?vue&type=template&id=84a44406"
import script from "./CreateBinNumber.vue?vue&type=script&lang=js"
export * from "./CreateBinNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports